import { type ProjectActivity } from "@selector/shared/graphql";
import Fuse from "fuse.js";

const SEARCH_KEYS = [
  "commentBody",
  "projectName",
  "type",
  "user.username",
  "user.display",
  "user.email",
  "affectedUsers.username",
  "affectedUsers.display",
  "affectedUsers.email",
  "groups.name",
  "deletedGroups.name",
  "views.name",
  "parents.name",
  "parents.description",
  "parents.typeDisplayName",
  "coordinateLists.name",
  "coordinateLists.description",
  "coordinateLists.typeDisplayName",
  "projectFiles.fileName",
  "projectFiles.description",
  "projectFiles.typeDisplayName",
  "projectFiles.path",
  "projectFiles.fullPath",
  "flags.name",
  "flags.description",
  "flags.typeDisplayName",
  "flags.region.contig.sequenceId",
  "flags.region.contig.name",
  "flags.region.range.start",
  "flags.region.range.stop",
  "playbookEvent.name",
  "playbookEvent.description",
  "project.userGroup.name",
  "project.description",
];

const FUSE_OPTIONS: Fuse.IFuseOptions<ProjectActivity> = {
  includeScore: false,
  shouldSort: false,
  threshold: 0.1,
  minMatchCharLength: 3,
  ignoreLocation: true,
  findAllMatches: true,
  keys: SEARCH_KEYS,
};

const sortByRefIndex = (a: Fuse.FuseResult<ProjectActivity>, b: Fuse.FuseResult<ProjectActivity>): number => {
  if (a.refIndex == null || b.refIndex == null) {
    return 0;
  }
  return a.refIndex - b.refIndex;
};

export const filterProjectActivities = (activities: ProjectActivity[], searchQuery: string): ProjectActivity[] => {
  if (!activities?.length) {
    return [];
  }

  const trimmedQuery = searchQuery?.trim();
  if (!trimmedQuery) {
    return activities.slice();
  }

  const fuse = new Fuse<ProjectActivity>(activities, FUSE_OPTIONS);
  return fuse
    .search(trimmedQuery)
    .sort(sortByRefIndex)
    .map((result) => result.item);
};
